import { createContext } from 'react';
import { TLoadingContext } from './types';

export const LoadingContext = createContext<TLoadingContext>({
  loadingState: { clientDetailsLoading: false, isTreatmentLoading: false },
  loadingDispatch: () => ({}),
});
